import { render } from "./Prompt.vue?vue&type=template&id=4ba7c986&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"

import "./Prompt.vue?vue&type=style&index=0&id=4ba7c986&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=4ba7c986&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba7c986"]])

export default __exports__